import { type FC } from 'react';

import { Text } from '../common/Text';
import { IntegrationsHeroGlobeIcon } from '../IntegrationsHero/IntegrationsHeroIcons';

import { IntegrationScenarioCardIcon } from './IntegrationScenarioCardIcon';
import { formatMethod, getPaymentSystemTags, TRANSACTION_LABELS } from './integrationScenarioHelpers';
import type { IntegrationScenario } from './integrationScenariosData';
import styles from './IntegrationsScenariosBlock.module.scss';

type ScenarioCardProps = {
  scenario: IntegrationScenario;
};

export const ScenarioCard: FC<ScenarioCardProps> = (props) => {
  const { scenario } = props;

  const transactionLabel = TRANSACTION_LABELS[scenario.transactionType];
  const paymentTags = getPaymentSystemTags(scenario);

  return (
    <article className={styles.card}>
      <div className={styles.cardTop}>
        <div className={styles.typeBadges}>
          <span className={styles.typeBadge}>{transactionLabel}</span>
        </div>

        <div className={styles.cardIconWrap} aria-hidden>
          {scenario.icon === 'globe' ? <IntegrationsHeroGlobeIcon /> : <IntegrationScenarioCardIcon />}
        </div>
      </div>

      <Text type="h3" color="white" className={styles.cardTitle}>
        {scenario.title}
      </Text>

      <div className={styles.descriptionGrow}>
        <Text type="regular14" color="white50" whiteSpace="normal" className={styles.cardDescription}>
          {scenario.description}
        </Text>
      </div>

      <dl className={styles.details}>
        <div className={styles.detailRow}>
          <dt>
            <Text type="regular14" className={styles.detailLabel}>
              Method
            </Text>
          </dt>

          <dd className={styles.detailDd}>
            <Text type="regular14" color="white">
              {formatMethod(scenario.method)}
            </Text>
          </dd>
        </div>

        <div className={styles.detailRow}>
          <dt>
            <Text type="regular14" className={styles.detailLabel}>
              GEO
            </Text>
          </dt>

          <dd className={styles.detailDd}>
            <Text type="regular14" color="white">
              {scenario.geo}
            </Text>
          </dd>
        </div>

        <div className={styles.detailRow}>
          <dt>
            <Text type="regular14" className={styles.detailLabel}>
              Currency
            </Text>
          </dt>

          <dd className={styles.detailDd}>
            <div className={styles.currencyPills}>
              {scenario.currencies.map((c) => (
                <span key={c} className={styles.currencyPill}>
                  {c}
                </span>
              ))}
            </div>
          </dd>
        </div>
      </dl>

      <div className={styles.tagRow}>
        {paymentTags.map((tag) => (
          <span key={tag} className={styles.tag}>
            {tag}
          </span>
        ))}
      </div>
    </article>
  );
};
